// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__35OAb","vLegacy":"SelectSecondary_vLegacy__8fevC","error":"SelectSecondary_error__3eqxz","disabled":"SelectSecondary_disabled__1xF-b"};